// Componente que muestra el cartel de "Rehusados finalizado" cuando el estado es "Por ubicar".
// Component that displays the "Returns finished" banner when status is "To locate".
import { useTranslation } from 'react-i18next';
import { Button } from '@shared/components/ui/button';
import { Link } from 'react-router-dom';

export const FinishedBanner = () => {
  const { t } = useTranslation('receiveModule');

  return (
    <div className="w-full p-6 text-center">
      {/* Título principal - Main title */}
      <h3 className="text-success text-lg font-medium mb-2">{t('ui.finished_title')}</h3>

      {/* Mensaje descriptivo - Descriptive message */}
      <p className="text-complementary-text text-sm mb-4">{t('ui.finished_message')}</p>

      {/* Botón de navegación - Navigation button */}
      <Link to="/returned" className="inline-block" data-testid="back-to-returned-button">
        <Button variant="outline" className="mx-auto">
          {t('ui.back_to_returned')}
        </Button>
      </Link>
    </div>
  );
};
